import './index.css';

const DetailContainer = ({ children }) => {
    return (
        <div className="detail-container">
            {children}
        </div>
    )
}

export default DetailContainer;